import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const PostNotFound = () => {
  return (
    <Box flexGrow>
      <Box style={{ height: '80vh' }} gap="s16" alignItems="center" justifyContent="center">
        <Icon.Large icon="file" color="radicalRed1000" />
        <Text.Header2 color="grey1000">{i18n.t('posts.communities.post.not_found')}</Text.Header2>
      </Box>
    </Box>
  )
}

export default observer(PostNotFound)
